import Flyer from './Off-Flyer';
import { ReactComponent as Bookmark } from '../assets/icons/bookmark.svg';
import {ReactComponent as ReactLogo} from '../assets/icons/toman.svg';
import { useNavigate } from 'react-router-dom';

const Card = ({ data, onAddToCart, cartData, offRate }) => {
  const navigate = useNavigate();
  const isOut = data?.isactive === 1 || data?.isProvidable === 1;
const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  function toFarsiNumber(n) {
    

    return (parseInt(n).toLocaleString().toString().replace(/\d/g, (x) => farsiDigits[x]));
  }

  const discountCalculator = (originalPrice, discount) => {
    return originalPrice - (originalPrice * discount) / 100;
  };

  const isInArray = (item) => {
    const checkId = (obj) => obj.id === item.id;
    return cartData.some(checkId);
  };

  const onClick = (id) => {
    navigate(`/product/${id}`);
  };

  return (
    <div
      className='navigator__card h-fit border-sky-100 rounded-md w-36 sm:w-44 shadow-md relative flex-shrink-0 flex flex-col justify-between items-center overflow-hidden cursor-pointer transition-shadow hover:shadow-2xl'
      style={{ backgroundColor: 'white' }} // offRate > 0 ? '#449FFD' : 'white' }
      onClick={onClick.bind(null, data.id)}>
      {offRate > 0 && <Flyer amount={toFarsiNumber(offRate) + '%'} />}
      {!isOut && <p className='out_service text-red-600 pl-5'>خارج از ساعت</p>}
      <div className={`${isOut ? 'w-32' : 'w-32'} mt-4`}>
        <img className='h-full' src={data.thumb || data.thumb256} alt='' />
      </div>

      <div className='w-full h-full mb-0 sm:mb-1 flex flex-col justify-between items-center'>
        <p className='text-center p-2 product_name h-12'>
          {(data.name.length > 40
            ? data.name.slice(0, 40)+"..."
            : data.name).replace(/\d/g, (x) => farsiDigits[x])}
        </p>

        <div className='h-10 flex items-center justify-start content-start flex-col gap-1'>
          {offRate > 0 && (
            <div className='off_price flex flex-row-reverse justify-center gap-1'>
              <span className='text-center'>
                {toFarsiNumber(discountCalculator(data.price, offRate))}
              </span>
              <ReactLogo className='toman' />
            </div>
          )}

          <div
            className={`flex flex-row-reverse justify-center gap-1 mb-auto ${
              offRate > 0 ? 'line-through text-gray-700' : 'off_price'
            }`}>
            <span className='text-center'>
              {toFarsiNumber(data.price)}
            </span>{offRate == 0?<ReactLogo className='toman' />:null}            
          </div>
        </div>
      </div>

      <button
        className={`bg-green-600 cart-text-button text-white m-2 p-2 rounded-md ${
          cartData && isInArray(data) ? 'bg-red-600 hover:bg-red-500' : 'bg-green-600 hover:bg-green-500'
        }
        ${
          data.isAvailable <= 0 ? 'bg-gray-500 hover:bg-gray-500':''
        }`}
        style={{ width: '90%' }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onAddToCart(data);
        }}
        disabled={data.isAvailable <= 0}>
        {data.isAvailable <= 0 ? (
          'ناموجود'
        ) : (
          <>
            {cartData && isInArray(data) ? 'حذف از سبد' : 'افزودن به سبد خرید'}
          </>
        )}
      </button>
    </div>
  );
};

export default Card;
